import { apiGet } from './api';

export interface CashAccount {
  userNum: number;
  cash: number;
  cashBonus: number;
  cashPending?: number;   // reembolso ainda nao consumido: bloqueia cartao cash
}

export interface RechargeKit {
  id: number;
  title?: string;
  cash: number;
  price: number;
  brl?: number;
  usd?: number;
  image?: string | null;
  active?: number;
  bonus?: number;          // cash bônus extra creditado junto (0 = sem bônus)
  value?: number;
  amount?: number;
  [key: string]: any;
}

export interface PremiumPackage {
  id: number;
  title: string;
  days: number;
  serviceKind: number;
  priceCash: number;
  discount?: number; // % 0-100 (default 0 = sem desconto)
}

export interface CashService {
  id: number;
  title: string;
  priceCash: number;
  route: string;
}

/** GET /Cash/get — saldo de cash */
export const getCash = () => apiGet<CashAccount>('/Cash/get');

/** GET /Cash/rechargeKits — pacotes de recarga */
export const getRechargeKits = () => apiGet<RechargeKit[]>('/Cash/rechargeKits');

/** GET /Cash/premiums — pacotes premium */
export const getPremiums = () => apiGet<PremiumPackage[]>('/Cash/premiums');

/** GET /Cash/premium — comprar premium */
export const buyPremium = (id: number) =>
  apiGet<{ status: string; message: string }>('/Cash/premium', { id });

/** GET /Cash/services — servicos disponiveis */
export const getServices = (character: number, account: number) =>
  apiGet<CashService[]>('/Cash/services', { character, account });

/** GET /Cash/service — usar servico */
export const useService = (id: number, param: number) =>
  apiGet<{ status: string; message: string }>('/Cash/service', { id, param });

/** GET /Cash/giftcard — comprar Cartao de Presente (1=Bronze, 2=Prata, 3=Ouro).
 *  quantity: 1..99 (default 1). Backend cobra price*quantity e cria N items. */
export const buyGiftCard = (kind: 1 | 2 | 3, quantity: number = 1) =>
  apiGet<{ status: string; message: string }>('/Cash/giftcard', { kind, quantity });
